import React from "react";
//#region types
import { ContentTreeProps } from "models/propTypes/contentTreePropTypes";
import { ContentTreeNode as ContentTreeNodeType } from "models/utilTypes/contentTreeTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ContentNode from "./contentNode";
//#endregion

const ContentTreeNode: React.FC<ContentTreeProps> = (props) => {
  const { nodes, parentIndex } = props;

  return (
    <Grid container item>
      {nodes.map((node, subTreeItemIndex) =>
        node instanceof ContentTreeNodeType ? (
          <React.Fragment key={`tree-${parentIndex}subTree-${subTreeItemIndex}`}>
            <ContentNode parentIndex={parentIndex} currentIndex={subTreeItemIndex + 1}>
              {node.mainText}
            </ContentNode>
            <ContentTreeNode
              nodes={node.subTree}
              parentIndex={`${parentIndex}. ${subTreeItemIndex + 1}`}
            ></ContentTreeNode>
          </React.Fragment>
        ) : (
          <ContentNode parentIndex={parentIndex} currentIndex={subTreeItemIndex + 1}>
            {node}
          </ContentNode>
        )
      )}
    </Grid>
  );
};

export default ContentTreeNode;
